// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1eXIO","body":"_30Qm9","index":"_1OzuP","icon":"_1Y8DA","point":"_2s68c"};